
export enum sectionType {
    _2C_M = "2C-M",
    _2C_MK = "2C-MK",
    _2C_MK_O_TLK = "2C-MK_O-TLK",
    _2C_M_O_TL = "2C-M_O-TL",
    _2C_S1S2BG2_1 = "2C-S1S2BG2_1",
    _2C_S1S2BG2_2 = "2C-S1S2BG2_2",
    _2C_S1S2BG_1 = "2C-S1S2BG_1",
    _2C_S1S2BG_2 = "2C-S1S2BG_2",
    _2C_S1S2K_1 = "2C-S1S2K_1",
    _2C_S1S2K_2 = "2C-S1S2K_2",
    _2C_S1S2_1 = "2C-S1S2_1",
    _2C_S1S2_2 = "2C-S1S2_2",
    _2C_XLBG2_1 = "2C-XLBG2_1",
    _2C_XLBG2_2 = "2C-XLBG2_2",
    _2C_XLBG_1 = "2C-XLBG_1",
    _2C_XLBG_2 = "2C-XLBG_2",
    _2C_XLK_1 = "2C-XLK_1",
    _2C_XLK_2 = "2C-XLK_2",
    _2C_XL_1 = "2C-XL_1",
    _2C_XL_2 = "2C-XL_2",
    _2C_XSK_C_MK_O_TLK = "2C-XSK_C-MK_O-TLK",
    _2C_XSK_O_TLK = "2C-XSK_O-TLK",
    _2C_XS_C_M_O_TL = "2C-XS_C-M_O-TL",
    _2C_XS_O_TL = "2C-XS_O-TL",
    _2G_LBG2_O_TH2BG2_R_H = "2G-LBG2_O-TH2BG2_R_H",
    _2G_LBG2_O_TLH2BG2_R_H = "2G-LBG2_O-TLH2BG2_R_H",
    _2G_LBG_O_TH2BG_R_H = "2G-LBG_O-TH2BG_R_H",
    _2G_LBG_O_TLH2BG_R_H = "2G-LBG_O-TLH2BG_R_H",
    _2G_LK_O_TH2K_R_H = "2G-LK_O-TH2K_R_H",
    _2G_LK_O_TLH2K_R_H = "2G-LK_O-TLH2K_R_H",
    _2G_L_O_TH2_R_H = "2G-L_O-TH2_R_H",
    _2G_L_O_TLH2_R_H = "2G-L_O-TLH2_R_H",
    _2G_MBG2_O_TH2BG2_R = "2G-MBG2_O-TH2BG2_R",
    _2G_MBG2_O_TH2BG2_R_H = "2G-MBG2_O-TH2BG2_R_H",
    _2G_MBG2_O_TLH2BG2_R_H = "2G-MBG2_O-TLH2BG2_R_H",
    _2G_MBG2_R = "2G-MBG2_R",
    _2G_MBG_O_TH2BG_R = "2G-MBG_O-TH2BG_R",
    _2G_MBG_O_TH2BG_R_H = "2G-MBG_O-TH2BG_R_H",
    _2G_MBG_O_TLH2BG_R_H = "2G-MBG_O-TLH2BG_R_H",
    _2G_MBG_R = "2G-MBG_R",
    _2G_MK_O_TH2K_R = "2G-MK_O-TH2K_R",
    _2G_MK_O_TH2K_R_H = "2G-MK_O-TH2K_R_H",
    _2G_MK_O_TLH2K_R_H = "2G-MK_O-TLH2K_R_H",
    _2G_MK_R = "2G-MK_R",
    _2G_M_O_TH2_R = "2G-M_O-TH2_R",
    _2G_M_O_TH2_R_H = "2G-M_O-TH2_R_H",
    _2G_M_O_TLH2_R_H = "2G-M_O-TLH2_R_H",
    _2G_M_R = "2G-M_R",
    _2G_XSK_O_TH2K_R = "2G-XSK_O-TH2K_R",
    _2G_XSK_O_TLH2K_R = "2G-XSK_O-TLH2K_R",
    _2G_XS_O_TH2_R = "2G-XS_O-TH2_R",
    _2G_XS_O_TLH2_R = "2G-XS_O-TLH2_R",
    _2H_L3K_O_TH2K_R = "2H-L3K_O-TH2K_R",
    _2H_L3SK_O_TH2K_R_H = "2H-L3SK_O-TH2K_R_H",
    _2H_L3SK_R = "2H-L3SK_R",
    _2H_L3S_O_TLH2_R_H = "2H-L3S_O-TLH2_R_H",
    _2H_L3_O_TH2K_R_H = "2H-L3_O-TH2K_R_H",
    _2H_L3_O_TLH2_R_H = "2H-L3_O-TLH2_R_H",
    _2H_LBG_O_TH2BG2_R_H = "2H-LBG_O-TH2BG2_R_H",
    _2H_LBG_O_TLH2BG2_R_H = "2H-LBG_O-TLH2BG2_R_H",
    _2H_LK_O_TH2K_R = "2H-LK_O-TH2K_R",
    _2H_LK_O_TH2K_R_H = "2H-LK_O-TH2K_R_H",
    _2H_LK_O_TLH2K_R_H = "2H-LK_O-TLH2K_R_H",
    _2H_LSBG_O_TH2BG_R_H = "2H-LSBG_O-TH2BG_R_H",
    _2H_LSBG_O_TLH2BG_R_H = "2H-LSBG_O-TLH2BG_R_H",
    _2H_LSBG_R = "2H-LSBG_R",
    _2H_LSK_O_TH2K_R_H = "2H-LSK_O-TH2K_R_H",
    _2H_LSK_O_TLH2K_R_H = "2H-LSK_O-TLH2K_R_H",
    _2H_LSK_R = "2H-LSK_R",
    _3C_XSK_O_TLK = "3C-XSK_O-TLK",
    _3C_XS_O_TL = "3C-XS_O-TL",
    _4C_XSK_O_TLK = "4C-XSK_O-TLK",
    _4C_XS_O_TL = "4C-XS_O-TL",
    _4G_XSBG2_O_TH2BG2_R_H = "4G-XSBG2_O-TH2BG2_R_H",
    _4G_XSBG2_O_TLH2BG2_R_H = "4G-XSBG2_O-TLH2BG2_R_H",
    _4G_XSBG_O_TH2BG_R_H = "4G-XSBG_O-TH2BG_R_H",
    _4G_XSBG_O_TLH2BG_R_H = "4G-XSBG_O-TLH2BG_R_H",
    _4G_XSK_O_TH2K_R_H = "4G-XSK_O-TH2K_R_H",
    _4G_XSK_O_TLH2K_R_H = "4G-XSK_O-TLH2K_R_H",
    _4G_XS_O_TH2_R_H = "4G-XS_O-TH2_R_H",
    _4G_XS_O_TLH2_R_H = "4G-XS_O-TLH2_R_H",
    _6C_XSBG2_1 = "6C-XSBG2_1",
    _6C_XSBG2_2 = "6C-XSBG2_2",
    _6C_XSBG_1 = "6C-XSBG_1",
    _6C_XSBG_2 = "6C-XSBG_2",
    _6C_XSK_1 = "6C-XSK_1",
    _6C_XSK_2 = "6C-XSK_2",
    _6C_XS_1 = "6C-XS_1",
    _6C_XS_2 = "6C-XS_2",
    C_LBG_O_T2_R = "C-LBG_O-T2_R",
    C_LBG_O_T_R = "C-LBG_O-T_R",
    C_LK_2C_XSK = "C-LK_2C-XSK",
    C_LK_C_MK = "C-LK_C-MK",
    C_LK_C_XSK = "C-LK_C-XSK",
    C_LK_O_T_R = "C-LK_O-T_R",
    C_L_2C_XS = "C-L_2C-XS",
    C_L_C_M = "C-L_C-M",
    C_L_C_XS = "C-L_C-XS",
    C_L_O_T_R = "C-L_O-T_R",
    C_MBG2_R = "C-MBG2_R",
    C_MBG_R = "C-MBG_R",
    C_MK_O_TLK = "C-MK_O-TLK",
    C_MK_R = "C-MK_R",
    C_M_O_TL = "C-M_O-TL",
    C_M_R = "C-M_R",
    C_S1S2BG2_1 = "C-S1S2BG2_1",
    C_S1S2BG2_2 = "C-S1S2BG2_2",
    C_S1S2BG2_R = "C-S1S2BG2_R",
    C_S1S2BG_1 = "C-S1S2BG_1",
    C_S1S2BG_2 = "C-S1S2BG_2",
    C_S1S2BG_R = "C-S1S2BG_R",
    C_S1S2K_1 = "C-S1S2K_1",
    C_S1S2K_2 = "C-S1S2K_2",
    C_S1S2K_C_MK = "C-S1S2K_C-MK",
    C_S1S2K_O_TLK = "C-S1S2K_O-TLK",
    C_S1S2K_R = "C-S1S2K_R",
    C_S1S2_1 = "C-S1S2_1",
    C_S1S2_2 = "C-S1S2_2",
    C_S1S2_C_M = "C-S1S2_C-M",
    C_S1S2_O_TL = "C-S1S2_O-TL",
    C_S1S2_R = "C-S1S2_R",
    C_XLBG2_R = "C-XLBG2_R",
    C_XLBG_R = "C-XLBG_R",
    C_XLK_C_MK = "C-XLK_C-MK",
    C_XLK_O_TLK = "C-XLK_O-TLK",
    C_XLK_R = "C-XLK_R",
    C_XL_C_M = "C-XL_C-M",
    C_XL_O_TL = "C-XL_O-TL",
    C_XL_R = "C-XL_R",
    C_XSBG2_R = "C-XSBG2_R",
    C_XSBG_R = "C-XSBG_R",
    C_XSK_2C_MK = "C-XSK_2C-MK",
    C_XSK_C_MK = "C-XSK_C-MK",
    C_XSK_C_MK_O_TLK = "C-XSK_C-MK_O-TLK",
    C_XSK_C_S1S2K = "C-XSK_C-S1S2K",
    C_XSK_C_S1S2K_O_TLK = "C-XSK_C-S1S2K_O-TLK",
    C_XSK_C_XLK = "C-XSK_C-XLK",
    C_XSK_C_XLK_O_TLK = "C-XSK_C-XLK_O-TLK",
    C_XSK_R = "C-XSK_R",
    C_XS_2C_M = "C-XS_2C-M",
    C_XS_C_M = "C-XS_C-M",
    C_XS_C_M_O_TL = "C-XS_C-M_O-TL",
    C_XS_C_S1S2 = "C-XS_C-S1S2",
    C_XS_C_S1S2_O_TL = "C-XS_C-S1S2_O-TL",
    C_XS_C_XL = "C-XS_C-XL",
    C_XS_C_XL_O_TL = "C-XS_C-XL_O-TL",
    C_XS_R = "C-XS_R",
    G_L1L2BG2_R = "G-L1L2BG2_R",
    G_L1L2BG_R = "G-L1L2BG_R",
    G_L1L2K_R = "G-L1L2K_R",
    G_L1L2_R = "G-L1L2_R",
    G_L2K = "G-L2K",
    G_L2T = "G-L2T",
    G_L2TBG = "G-L2TBG",
    G_L2TBG2 = "G-L2TBG2",
    G_MBG2_O_TH2_R = "G-MBG2_O-TH2_R",
    G_MBG2_O_TLH2_R = "G-MBG2_O-TLH2_R",
    G_MBG2_R = "G-MBG2_R",
    G_MBG_O_TH2_R = "G-MBG_O-TH2_R",
    G_MBG_O_TLH2_R = "G-MBG_O-TLH2_R",
    G_MBG_R = "G-MBG_R",
    G_MK_2G_XSK_O_TH2K_R = "G-MK_2G-XSK_O-TH2K_R",
    G_MK_2G_XSK_O_TLH2K_R = "G-MK_2G-XSK_O-TLH2K_R",
    G_MK_G_XSK_O_TH2K_R = "G-MK_G-XSK_O-TH2K_R",
    G_MK_G_XSK_O_TLH2K_R = "G-MK_G-XSK_O-TLH2K_R",
    G_MK_O_TH2K_R = "G-MK_O-TH2K_R",
    G_MK_O_TLH2K_R = "G-MK_O-TLH2K_R",
    G_MK_R = "G-MK_R",
    G_M_2G_XS_O_TH2_R = "G-M_2G-XS_O-TH2_R",
    G_M_2G_XS_O_TLH2_R = "G-M_2G-XS_O-TLH2_R",
    G_M_G_XS_O_TH2_R = "G-M_G-XS_O-TH2_R",
    G_M_G_XS_O_TLH2_R = "G-M_G-XS_O-TLH2_R",
    G_M_O_TH2_R = "G-M_O-TH2_R",
    G_M_O_TLH2_R = "G-M_O-TLH2_R",
    G_M_R = "G-M_R",
    G_S1S2BG2_R = "G-S1S2BG2_R",
    G_S1S2BG_R = "G-S1S2BG_R",
    G_S1S2K_G_XSK_O_TH2K_R = "G-S1S2K_G-XSK_O-TH2K_R",
    G_S1S2K_O_TH2K_R = "G-S1S2K_O-TH2K_R",
    G_S1S2K_O_TLH2K_R = "G-S1S2K_O-TLH2K_R",
    G_S1S2K_R = "G-S1S2K_R",
    G_S1S2_G_XS_O_TH2_R = "G-S1S2_G-XS_O-TH2_R",
    G_S1S2_O_TH2_R = "G-S1S2_O-TH2_R",
    G_S1S2_O_TLH2_R = "G-S1S2_O-TLH2_R",
    G_S1S2_R = "G-S1S2_R",
    G_XLBG2_O_TH2BG_R = "G-XLBG2_O-TH2BG_R",
    G_XLBG2_O_TLH2BG_R = "G-XLBG2_O-TLH2BG_R",
    G_XLBG2_R = "G-XLBG2_R",
    G_XLBG_O_TH2BG_R = "G-XLBG_O-TH2BG_R",
    G_XLBG_O_TLH2BG_R = "G-XLBG_O-TLH2BG_R",
    G_XLBG_R = "G-XLBG_R",
    G_XLK_O_TH2K_R = "G-XLK_O-TH2K_R",
    G_XLK_O_TLH2K_R = "G-XLK_O-TLH2K_R",
    G_XLK_R = "G-XLK_R",
    G_XL_O_TH2_R = "G-XL_O-TH2_R",
    G_XL_O_TLH2_R = "G-XL_O-TLH2_R",
    G_XL_R = "G-XL_R",
    H_L3K_O_TH2K_R = "H-L3K_O-TH2K_R",
    H_L3K_O_TLH2K_R = "H-L3K_O-TLH2K_R",
    H_L3K_R = "H-L3K_R",
    H_L3_R = "H-L3_R",
    H_LBG_O_TH2BG_R = "H-LBG_O-TH2BG_R",
    H_LBG_O_TLH2BG_R = "H-LBG_O-TLH2BG_R",
    H_LBG_R = "H-LBG_R",
    H_LK_O_TH2K_R = "H-LK_O-TH2K_R",
    H_LK_O_TLH2K_R = "H-LK_O-TLH2K_R",
    H_LK_R = "H-LK_R",
    H_L_R = "H-L_R",
    H_M13M23K_O_TH2K_R = "H-M13M23K_O-TH2K_R",
    H_M13M23K_O_TLH2K_R = "H-M13M23K_O-TLH2K_R",
    H_M13M23K_R = "H-M13M23K_R",
    H_M13M23_R = "H-M13M23_R",
    H_M1M2BG_R = "H-M1M2BG_R",
    H_M1M2K_O_TH2K_R = "H-M1M2K_O-TH2K_R",
    H_M1M2K_O_TLH2K_R = "H-M1M2K_O-TLH2K_R",
    H_M1M2K_R = "H-M1M2K_R",
    H_M1M2_R = "H-M1M2_R",
    H_SL3K_O_TH2K_R = "H-SL3K_O-TH2K_R",
    H_SL3K_O_TLH2K_R = "H-SL3K_O-TLH2K_R",
    H_SL3K_R = "H-SL3K_R",
    H_SLBG_O_TH2BG_R = "H-SLBG_O-TH2BG_R",
    H_SLBG_O_TLH2BG_R = "H-SLBG_O-TLH2BG_R",
    H_SLBG_R = "H-SLBG_R",
    H_SLK_O_TH2K_R = "H-SLK_O-TH2K_R",
    H_SLK_O_TLH2K_R = "H-SLK_O-TLH2K_R",
    H_SLK_R = "H-SLK_R",
    H_S_R = "H-S_R",
    O_TBG_R = "O-TBG_R",
    O_TH2BG2_2G_LBG2_R_H = "O-TH2BG2_2G-LBG2_R_H",
    O_TH2BG2_2G_MBG2_R = "O-TH2BG2_2G-MBG2_R",
    O_TH2BG2_2G_MBG2_R_H = "O-TH2BG2_2G-MBG2_R_H",
    O_TH2BG2_2H_LBG_R_H = "O-TH2BG2_2H-LBG_R_H",
    O_TH2BG2_4G_XSBG2_R_H = "O-TH2BG2_4G-XSBG2_R_H",
    O_TH2BG2_R = "O-TH2BG2_R",
    O_TH2BG_2G_LBG_R_H = "O-TH2BG_2G-LBG_R_H",
    O_TH2BG_2G_MBG_R = "O-TH2BG_2G-MBG_R",
    O_TH2BG_2G_MBG_R_H = "O-TH2BG_2G-MBG_R_H",
    O_TH2BG_2H_LSBG_R_H = "O-TH2BG_2H-LSBG_R_H",
    O_TH2BG_4G_XSBG_R_H = "O-TH2BG_4G-XSBG_R_H",
    O_TH2BG_G_XLBG2_R = "O-TH2BG_G-XLBG2_R",
    O_TH2BG_G_XLBG_R = "O-TH2BG_G-XLBG_R",
    O_TH2BG_H_LBG_R = "O-TH2BG_H-LBG_R",
    O_TH2BG_H_SLBG_R = "O-TH2BG_H-SLBG_R",
    O_TH2BG_R = "O-TH2BG_R",
    O_TH2K_2G_LK_R_H = "O-TH2K_2G-LK_R_H",
    O_TH2K_2G_MK_R = "O-TH2K_2G-MK_R",
    O_TH2K_2G_MK_R_H = "O-TH2K_2G-MK_R_H",
    O_TH2K_2G_XSK_R = "O-TH2K_2G-XSK_R",
    O_TH2K_2H_L3K_R = "O-TH2K_2H-L3K_R",
    O_TH2K_2H_L3K_R_H = "O-TH2K_2H-L3K_R_H",
    O_TH2K_2H_L3SK_R_H = "O-TH2K_2H-L3SK_R_H",
    O_TH2K_2H_LK_R = "O-TH2K_2H-LK_R",
    O_TH2K_2H_LK_R_H = "O-TH2K_2H-LK_R_H",
    O_TH2K_2H_LSK_R_H = "O-TH2K_2H-LSK_R_H",
    O_TH2K_4G_XSK_R_H = "O-TH2K_4G-XSK_R_H",
    O_TH2K_G_MK_2G_XSK_R = "O-TH2K_G-MK_2G-XSK_R",
    O_TH2K_G_MK_G_XSK_R = "O-TH2K_G-MK_G-XSK_R",
    O_TH2K_G_MK_R = "O-TH2K_G-MK_R",
    O_TH2K_G_S1S2K_G_XSK_R = "O-TH2K_G-S1S2K_G-XSK_R",
    O_TH2K_G_S1S2K_R = "O-TH2K_G-S1S2K_R",
    O_TH2K_G_XLK_R = "O-TH2K_G-XLK_R",
    O_TH2K_H_L3K_R = "O-TH2K_H-L3K_R",
    O_TH2K_H_LK_R = "O-TH2K_H-LK_R",
    O_TH2K_H_M13M23K_R = "O-TH2K_H-M13M23K_R",
    O_TH2K_H_M1M2K_R = "O-TH2K_H-M1M2K_R",
    O_TH2K_H_SL3K_R = "O-TH2K_H-SL3K_R",
    O_TH2K_H_SLK_R = "O-TH2K_H-SLK_R",
    O_TH2K_R = "O-TH2K_R",
    O_TH2_2G_L_R_H = "O-TH2_2G-L_R_H",
    O_TH2_2G_M_R = "O-TH2_2G-M_R",
    O_TH2_2G_M_R_H = "O-TH2_2G-M_R_H",
    O_TH2_2G_XS_R = "O-TH2_2G-XS_R",
    O_TH2_4G_XS_R_H = "O-TH2_4G-XS_R_H",
    O_TH2_G_MBG2_R = "O-TH2_G-MBG2_R",
    O_TH2_G_MBG_R = "O-TH2_G-MBG_R",
    O_TH2_G_M_2G_XS_R = "O-TH2_G-M_2G-XS_R",
    O_TH2_G_M_G_XS_R = "O-TH2_G-M_G-XS_R",
    O_TH2_G_M_R = "O-TH2_G-M_R",
    O_TH2_G_S1S2_G_XS_R = "O-TH2_G-S1S2_G-XS_R",
    O_TH2_G_S1S2_R = "O-TH2_G-S1S2_R",
    O_TH2_G_XL_R = "O-TH2_G-XL_R",
    O_TH2_R = "O-TH2_R",
    O_TK_R = "O-TK_R",
    O_TLBG2_R = "O-TLBG2_R",
    O_TLBG_R = "O-TLBG_R",
    O_TLH2BG2_2G_LBG2_R_H = "O-TLH2BG2_2G-LBG2_R_H",
    O_TLH2BG2_2G_MBG2_R_H = "O-TLH2BG2_2G-MBG2_R_H",
    O_TLH2BG2_4G_XSBG2_R_H = "O-TLH2BG2_4G-XSBG2_R_H",
    O_TLH2BG2_R = "O-TLH2BG2_R",
    O_TLH2BG_2G_LBG_R_H = "O-TLH2BG_2G-LBG_R_H",
    O_TLH2BG_2G_MBG_R_H = "O-TLH2BG_2G-MBG_R_H",
    O_TLH2BG_2H_LBG_R_H = "O-TLH2BG_2H-LBG_R_H",
    O_TLH2BG_2H_LSBG_R_H = "O-TLH2BG_2H-LSBG_R_H",
    O_TLH2BG_4G_XSBG_R_H = "O-TLH2BG_4G-XSBG_R_H",
    O_TLH2BG_G_XLBG2_R = "O-TLH2BG_G-XLBG2_R",
    O_TLH2BG_G_XLBG_R = "O-TLH2BG_G-XLBG_R",
    O_TLH2BG_H_LBG_R = "O-TLH2BG_H-LBG_R",
    O_TLH2BG_H_SLBG_R = "O-TLH2BG_H-SLBG_R",
    O_TLH2BG_R = "O-TLH2BG_R",
    O_TLH2K_2G_LK_R_H = "O-TLH2K_2G-LK_R_H",
    O_TLH2K_2G_MK_R_H = "O-TLH2K_2G-MK_R_H",
    O_TLH2K_2G_XSK_R = "O-TLH2K_2G-XSK_R",
    O_TLH2K_2H_L3K_R_H = "O-TLH2K_2H-L3K_R_H",
    O_TLH2K_2H_L3SK_R_H = "O-TLH2K_2H-L3SK_R_H",
    O_TLH2K_2H_LK_R_H = "O-TLH2K_2H-LK_R_H",
    O_TLH2K_2H_LSK_R_H = "O-TLH2K_2H-LSK_R_H",
    O_TLH2K_4G_XSK_R_H = "O-TLH2K_4G-XSK_R_H",
    O_TLH2K_G_MK_2G_XSK_R = "O-TLH2K_G-MK_2G-XSK_R",
    O_TLH2K_G_MK_G_XSK_R = "O-TLH2K_G-MK_G-XSK_R",
    O_TLH2K_G_MK_R = "O-TLH2K_G-MK_R",
    O_TLH2K_G_S1S2K_R = "O-TLH2K_G-S1S2K_R",
    O_TLH2K_G_XLK_R = "O-TLH2K_G-XLK_R",
    O_TLH2K_H_L3K_R = "O-TLH2K_H-L3K_R",
    O_TLH2K_H_LK_R = "O-TLH2K_H-LK_R",
    O_TLH2K_H_M13M23K_R = "O-TLH2K_H-M13M23K_R",
    O_TLH2K_H_M1M2K_R = "O-TLH2K_H-M1M2K_R",
    O_TLH2K_H_SL3K_R = "O-TLH2K_H-SL3K_R",
    O_TLH2K_H_SLK_R = "O-TLH2K_H-SLK_R",
    O_TLH2K_R = "O-TLH2K_R",
    O_TLH2_2G_L_R_H = "O-TLH2_2G-L_R_H",
    O_TLH2_2G_M_R_H = "O-TLH2_2G-M_R_H",
    O_TLH2_2G_XS_R = "O-TLH2_2G-XS_R",
    O_TLH2_4G_XS_R_H = "O-TLH2_4G-XS_R_H",
    O_TLH2_G_MBG2_R = "O-TLH2_G-MBG2_R",
    O_TLH2_G_MBG_R = "O-TLH2_G-MBG_R",
    O_TLH2_G_M_2G_XS_R = "O-TLH2_G-M_2G-XS_R",
    O_TLH2_G_M_G_XS_R = "O-TLH2_G-M_G-XS_R",
    O_TLH2_G_M_R = "O-TLH2_G-M_R",
    O_TLH2_G_S1S2_R = "O-TLH2_G-S1S2_R",
    O_TLH2_G_XL_R = "O-TLH2_G-XL_R",
    O_TLH2_R = "O-TLH2_R",
    O_TLK_2C_MK = "O-TLK_2C-MK",
    O_TLK_2C_XSK = "O-TLK_2C-XSK",
    O_TLK_2C_XSK_C_MK = "O-TLK_2C-XSK_C-MK",
    O_TLK_3C_XSK = "O-TLK_3C-XSK",
    O_TLK_4C_XSK = "O-TLK_4C-XSK",
    O_TLK_C_MK = "O-TLK_C-MK",
    O_TLK_C_S1S2K = "O-TLK_C-S1S2K",
    O_TLK_C_XLK = "O-TLK_C-XLK",
    O_TLK_C_XLK_C_XSK = "O-TLK_C-XLK_C-XSK",
    O_TLK_C_XSK_C_MK = "O-TLK_C-XSK_C-MK",
    O_TLK_C_XSK_C_S1S2K = "O-TLK_C-XSK_C-S1S2K",
    O_TLK_R = "O-TLK_R",
    O_TL_2C_M = "O-TL_2C-M",
    O_TL_2C_XS = "O-TL_2C-XS",
    O_TL_2C_XS_C_M = "O-TL_2C-XS_C-M",
    O_TL_3C_XS = "O-TL_3C-XS",
    O_TL_4C_XS = "O-TL_4C-XS",
    O_TL_C_M = "O-TL_C-M",
    O_TL_C_S1S2 = "O-TL_C-S1S2",
    O_TL_C_XL = "O-TL_C-XL",
    O_TL_C_XL_C_XS = "O-TL_C-XL_C-XS",
    O_TL_C_XS_C_M = "O-TL_C-XS_C-M",
    O_TL_C_XS_C_S1S2 = "O-TL_C-XS_C-S1S2",
    O_TL_R = "O-TL_R",
    O_TVBG2_R = "O-TVBG2_R",
    O_TVBG_R = "O-TVBG_R",
    O_TVC1BG2_R = "O-TVC1BG2_R",
    O_TVC1_R = "O-TVC1_R",
    O_TVC2BG2_R = "O-TVC2BG2_R",
    O_TVC2_R = "O-TVC2_R",
    O_TVC_R = "O-TVC_R",
    O_TV_R = "O-TV_R",
    O_T_R = "O-T_R",
    O_X4BG2_R = "O-X4BG2_R",
    O_X4BG_R = "O-X4BG_R",
    O_X4K_R = "O-X4K_R",
    O_X4_R = "O-X4_R",
    O_X5BG2_R = "O-X5BG2_R",
    O_X5BG_R = "O-X5BG_R",
    O_X5K_R = "O-X5K_R",
    O_X5_R = "O-X5_R",
    O_X6BG2_R = "O-X6BG2_R",
    O_X6BG_R = "O-X6BG_R",
    O_X6K_R = "O-X6K_R",
    O_X6_R = "O-X6_R",
    V_P312_R = "V-P312_R",
    V_P31_R = "V-P31_R",
    V_P322_R = "V-P322_R",
    V_P32T_R = "V-P32T_R",
    V_P32_R = "V-P32_R",
    V_P3T_R = "V-P3T_R",
    V_P412H_R = "V-P412H_R",
    V_P412_R = "V-P412_R",
    V_P41H_R = "V-P41H_R",
    V_P41_R = "V-P41_R",
    V_P422H_R = "V-P422H_R",
    V_P422_R = "V-P422_R",
    V_P42H_R = "V-P42H_R",
    V_P42T_R = "V-P42T_R",
    V_P42_R = "V-P42_R",
    V_P4T_R = "V-P4T_R",
    V_P512H_R = "V-P512H_R",
    V_P512_R = "V-P512_R",
    V_P51H_R = "V-P51H_R",
    V_P51_R = "V-P51_R",
    V_P522H_R = "V-P522H_R",
    V_P522_R = "V-P522_R",
    V_P52H_R = "V-P52H_R",
    V_P52T_R = "V-P52T_R",
    V_P52_R = "V-P52_R",
    V_P5T_R = "V-P5T_R",
    none = "none"
};
